export default "__VITE_ASSET__C7zLep6e__"